import * as types from "../constants/actionTypes";
import initialState from "./initialState";
import { ratesReducer } from "./ratesReducer";
import { availabilityReducer } from "./availabilityReducer";

//This reducer is not included in the root reducer
export const roomsReducer = (state = initialState.rooms, action) => {
  switch (action.type) {
    case types.GET_ROOM_RESULTS_FAIL:
    case types.RESET_ROOM_RESULTS: {
      return initialState.rooms;
    }

    case types.SORT_BY_LOWEST_PRICE:
    case types.GET_ROOM_RESULTS_SUCESS: {
      const nextState =
        state &&
        state &&
        state.filter(room => !room.alternativeSearch) &&
        state.filter(room => !room.alternativeSearch).map(room => {
          return roomReducer(room, action);
        });

      return nextState;
    }

    case types.PAX_REMOVED: {
      return (
        state &&
        state.filter(room => {
          room.id !== action.payload.paxId;
        })
      );
    }

    case types.RATE_SELECTED:
    case types.RATE_UNSELECTED: {
      const { roomId } = action.payload;
      const nextState =
        state &&
        state.map(room => {
          if (room.id !== roomId) {
            return room; // not the room of this selected rate
          }
          return roomReducer(room, action);
        });

      return nextState;
    }

    case types.FILTER_ROOMS_BY_ISPACKAGE: {
      return state && state.map(room => room.filter(rates => rates.isPackage));
    }

    default:
      return state;
  }
};

export const roomReducer = (state = {}, action) => {
  switch (action.type) {
    case types.SORT_BY_LOWEST_PRICE:
    case types.GET_ROOM_RESULTS_SUCESS:
    case types.RATE_SELECTED:
    case types.RATE_UNSELECTED: {
      const nextAvailability = availabilityReducer(state.availability, action);
      const extendedAction = {
        ...action,
        payload: {
          ...action.payload,
          roomInventory: nextAvailability
        }
      };
      return {
        ...state,
        availability: nextAvailability,
        rates: ratesReducer(state.rates, extendedAction)
      };
    }

    default:
      return state;
  }
};

export const roomsByRequestDescriptor = (state = {}, action) => {
  switch (action.type) {
    case types.GET_ROOM_RESULTS_SUCESS: {
      // we are getting array of rooms
      const rooms = action.payload && roomsReducer(action.payload, action);

      // convert it to a lookup table object [key === requestDescriptor]: [value === rooms]. ie: {0: [...rooms]}
      const groupByDescriptor = rooms && groopRoomsByDescriptor(rooms);
      const filteredRooms =
        groupByDescriptor &&
        getRoomsWithAvailabilitySelector(groupByDescriptor);
      return filteredRooms;
    }

    case types.RATE_SELECTED:
    case types.RATE_UNSELECTED: {
      const { RequestDescriptor } = action.payload;
      const nextState = Object.entries(state).reduce(
        (acc, [groupName, rooms]) => {
          if (groupName === RequestDescriptor.toString()) {
            return {
              ...state,
              ...acc
            };
          } else {
            return {
              ...acc,
              [groupName]: roomsReducer(rooms, action)
            };
          }
        },
        {}
      );

      return nextState;
    }

    case types.SORT_BY_LOWEST_PRICE: {
      const nextState = getRoomsWithSortedRates(state, action);
      return nextState;
    }

    case types.PAX_REMOVED: {
      const { paxId } = action.payload;
      const nextState = filterObjectByKeys(state, key => Number(key) !== paxId);
      return nextState;
    }

    case types.TOGGLE_EXPANDBLE_VIEW_FOR_ROOM: {
      const { requestDescriptor, id, name } = action.payload;
      const roomsByRequestDescriptor = state && state[requestDescriptor];
      const relevantRoom =
        roomsByRequestDescriptor &&
        roomsByRequestDescriptor.filter(
          room => room.id == id && room.name == name
        );
      let roomKey = Object.keys(relevantRoom);
      const newRoom = {
        [roomKey]: {
          ...relevantRoom[roomKey],
          ShowViewExpanded: !relevantRoom[roomKey]
        }
      };
      const newRoomsByRequestDescriptor = {
        ...roomsByRequestDescriptor,
        ...newRoom
      };
      const result = {
        ...state,
        [requestDescriptor]: { ...newRoomsByRequestDescriptor }
      };
      return result;
    }

    default:
      return state;
  }
};

export const displayRoomIdReducer = (
  state = initialState.displayRoomId,
  action
) => {
  switch (action.type) {
    case types.CHANGE_DISPLAY_ROOM:
      return action.payload;
    case types.RESET_DISPLAY_ROOM:
    case types.SELECTION_RESET:
      return initialState.displayRoomId;
    default:
      return state;
  }
};

export const getRoomByIdAndDescriptor = (state, id, descriptor) => {
  const room =
    state &&
    state[descriptor] &&
    state[descriptor].find(room => room.id === id);
  return room;
};

const groopRoomsByDescriptor = state => state.groupBy(x => x.requestDescriptor);

const getRoomsWithSortedRates = (state, action) => {
  const asArray = (state && Object.entries(state)) || [];
  const nextState =
    asArray &&
    asArray.reduce((result, [roomDescriptor, rooms]) => {
      result[roomDescriptor] = roomsReducer(rooms, action);
      return result;
    }, {});

  return nextState;
};

const filterObjectByKeys = (obj, predicate) => {
  const filtered = Object.keys(obj).filter(predicate);
  const nextObj = filtered.reduce((acc, key) => {
    return {
      ...acc,
      [key]: obj[key]
    };
  }, {});
  return nextObj;
};

const getRoomsWithAvailabilitySelector = state => {
  const roomsWithAvailability = Object.entries(state).reduce(
    (acc, [key, rooms]) => {
      const filteredRooms = rooms.filter(room => room.availability > 0);
      acc[key] = filteredRooms;
      return acc;
    },
    {}
  );
  return roomsWithAvailability;
};

export const getFirstRoomBySortOrder = state =>
  state.reduce(
    (prev, current) => (prev.sortOrder <= current.sortOrder ? prev : current)
  );



// WEBPACK FOOTER //
// ./src/reducers/roomResultsReducer.js